import React from "react";
import EditArtistSpotify from "../components/EditArtistSpotify";

const EditArtistSpotifyApp = (props) => <EditArtistSpotify {...props} />;

export default EditArtistSpotifyApp;
